
export default function Sponsors() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <span className="text-red-600">Organizadores</span> y Patrocinadores
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Gracias a todos los que hacen posible esta gran celebración deportiva 
            en la noche más especial del año.
          </p>
        </div>

        {/* Sponsors and Collaborators Image */}
        <div className="mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
            <img 
              src="https://static.readdy.ai/image/0d2a8bbfaad65247a8e821bed673477a/cfa32f6aab3c3cb930a31af222eaa707.png"
              alt="Patrocinadores y Colaboradores de la XX San Silvestre Zaragoza El Rincón"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        {/* Thank You Message */}
        <div className="bg-red-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">¡Gracias por hacer posible esta carrera!</h3>
          <p className="text-lg text-white/90 max-w-3xl mx-auto">
            Sin el apoyo de nuestros patrocinadores, colaboradores y voluntarios, 
            la XX San Silvestre Zaragoza El Rincón no sería posible. 
            ¡Gracias por ayudarnos a crear esta experiencia única!
          </p>
        </div>
      </div>
    </section>
  );
}
